module.exports = __webpack_public_path__ + "img/2-disabled.99ddabc1.png";